<template>
  <div>
    <app-header></app-header>

    <!-- Left side column. contains the sidebar -->
    <app-sidebar></app-sidebar>

    <!-- Content Wrapper. Contains page content -->
    <router-view></router-view>
    <!-- /.content-wrapper -->

    <app-footer></app-footer>
  </div>
</template>

<script>
  import Sidebar from './partials/Sidebar.vue'
  import Header from './partials/Header.vue'
  import Footer from './partials/Footer.vue'

  export default {
    name: 'Dashboard',
    components: {
      'app-sidebar': Sidebar,
      'app-header': Header,
      'app-footer': Footer
    },
    mounted: function () {
      $('ul').tree({animationSpeed: 200})
      $('ul').on('expanded.tree', function () {
        $(this).find('span i').removeClass('fa-angle-right').addClass('fa-angle-down')
      })
      $('ul').on('collapsed.tree', function () {
        $(this).find('span i').removeClass('fa-angle-down').addClass('fa-angle-right')
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Dashboard.vue?2da0d9b1